import { FiFile, FiPaperclip, FiTrash2 } from "react-icons/fi";
import { formatFileSize, RECEIPT_ACCEPT } from "../../utils/expenseReceipts";

export default function ExpenseReceiptUpload({
  pendingFiles,
  existingReceipts,
  onAddFiles,
  onRemovePending,
  onRemoveExisting,
}) {
  const handleFileChange = (event) => {
    const picked = Array.from(event.target.files || []);
    if (picked.length > 0) {
      onAddFiles(picked);
    }
    event.target.value = "";
  };

  const hasAny = existingReceipts.length > 0 || pendingFiles.length > 0;

  return (
    <div className="ui-modal-panel">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="ui-panel-title">Receipts</p>
          <p className="ui-muted mt-0.5 text-xs">Optional — PDF or images</p>
        </div>
        <label className="btn btn-sm btn-outline gap-1.5 rounded-lg">
          <FiPaperclip className="h-4 w-4" aria-hidden />
          Add files
          <input
            type="file"
            className="hidden"
            multiple
            accept={RECEIPT_ACCEPT}
            onChange={handleFileChange}
          />
        </label>
      </div>

      {existingReceipts.length > 0 ? (
        <ul className="mb-3 space-y-2">
          {existingReceipts.map((receipt) => (
            <li
              key={receipt.id}
              className="flex items-center justify-between gap-3 rounded-lg border border-base-200 bg-base-100 px-3 py-2.5"
            >
              <div className="flex min-w-0 items-center gap-2">
                <FiFile className="h-4 w-4 shrink-0 text-base-content/50" aria-hidden />
                <span className="truncate text-sm font-medium text-base-content">{receipt.name}</span>
              </div>
              <button
                type="button"
                className="btn btn-ghost btn-xs shrink-0 text-error"
                onClick={() => onRemoveExisting(receipt.id)}
                title="Remove receipt"
              >
                <FiTrash2 className="h-3.5 w-3.5" aria-hidden />
              </button>
            </li>
          ))}
        </ul>
      ) : null}

      {pendingFiles.length > 0 ? (
        <ul className="space-y-2">
          {pendingFiles.map((file, index) => (
            <li
              key={`${file.name}-${file.size}-${index}`}
              className="flex items-center justify-between gap-3 rounded-lg border border-dashed border-base-300 bg-base-200/30 px-3 py-2.5"
            >
              <div className="flex min-w-0 items-center gap-2">
                <FiFile className="h-4 w-4 shrink-0 text-primary/70" aria-hidden />
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-base-content">{file.name}</p>
                  <p className="text-xs text-base-content/50">{formatFileSize(file.size)}</p>
                </div>
              </div>
              <button
                type="button"
                className="btn btn-ghost btn-xs shrink-0 text-error"
                onClick={() => onRemovePending(index)}
                title="Remove file"
              >
                <FiTrash2 className="h-3.5 w-3.5" aria-hidden />
              </button>
            </li>
          ))}
        </ul>
      ) : !hasAny ? (
        <p className="text-xs text-base-content/50">No receipts attached yet.</p>
      ) : null}
    </div>
  );
}
